import React, {Component} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';

import requireAuth from '../auth/requireAuth';

import Run from './Run';

import * as actions from '../../actions/transform';
import {getTasks} from '../../actions/task';
import {DataAdminRole} from '../util/entitlements';

class Transforms extends Component {
	constructor(props) {
		super(props);
		this.runOne = this.runOne.bind(this);
		this.runSome = this.runSome.bind(this);
		this.runAll = this.runAll.bind(this);
		this.runManual = this.runManual.bind(this);
	}

	runOne(id, revisionID) {
		if (parseInt(id, 10) === 1) {
			this.props.runAnalystConversions(revisionID);
		} else if (parseInt(id, 10) === 2) {
			this.props.runAllTransforms(revisionID);
		}
	}

	runSome(ids, revisionID) {
		this.props.runAnalystConversions(revisionID);
	}

	runAll(revisionID) {
		this.props.runAnalystConversions(revisionID);
	}

	runManual({marketIDs, indicatorIDs}) {
		let marketsArray = [];
		if (marketIDs !== '') {
			marketsArray = marketIDs.split(',').map((id) => parseInt(id, 10));
		}
		let indicatorsArray = [];
		if (indicatorIDs !== '') {
			indicatorsArray = indicatorIDs.split(',').map((id) => parseInt(id, 10));
		}
		this.props.runManualTransform(marketsArray, indicatorsArray, this.props.revisions.currentRevisionID);
	}

	render() {
		if (this.props.transforms.order.length > 0 && this.props.revisions.currentRevisionID) {
			return (
				<Run
					label="Transform"
					runnables={this.props.transforms}
					runOne={this.runOne}
					runSome={this.runSome}
					runAll={this.runAll}
					runManual={this.runManual}
					getTasks={this.props.getTasks}
					revisionID={this.props.revisions.currentRevisionID}
					taskTypeID={8}
					checkType="radio"
				/>
			);
		} else {
			return <div>Loading...</div>;
		}
	}
}

function mapStateToProps({transforms, revisions}) {
	return {transforms, revisions};
}

export default compose(connect(mapStateToProps, {...actions, getTasks}), requireAuth(DataAdminRole))(Transforms);
